import ListingBanner from './ListingBanner.component';

export default ListingBanner;
